// The ONE reader of a role's display name.
//
// The ten seeded SYSTEM roles carry an i18n key in their `name` column
// (`apps/api/migrations/0002_tenancy.sql`: `('group_admin', 'roles.group_admin')`
// …), because a system role's label has to be localizable and the API has no
// locale to resolve it in. A tenant's OWN role (`POST /v1/identity/roles`)
// carries whatever the admin typed.
//
// So `role.name` is either a key or a human name, and printing it raw prints
// "roles.group_admin" to a factory admin — which is exactly what the plant
// map's invite control did, at both viewports, on the design partner's tenant
// (UX-1 surface review F5). This helper is the fix as a CLASS: translate when
// the name resolves to a real string, fall back to the name itself when it does
// not, so a custom role is never mangled and an unknown system key degrades to
// something readable rather than to a blank option.

import type { TFunction } from "i18next";

/** The display label for a role, whichever kind of `name` it carries. */
export function roleLabel(t: TFunction, name: string): string {
  // `defaultValue` is what makes the custom-role case safe: i18next returns it
  // verbatim when the key is absent, so nothing is ever rendered as a raw key.
  return t(name, { defaultValue: name });
}
